// @flow

import {
  createNestedAsyncTypes,
  createSingleAndManyAsyncTypes,
  createSingletonAsyncTypes,
} from './utils';

export const LOG_IN = 'LOG_IN';
export const LOG_OUT = 'LOG_OUT';
export const INIT = 'INIT';

export const GET_USER_ASYNC = createSingletonAsyncTypes('GET_USER');
export const GET_PROFILE_ASYNC = createSingletonAsyncTypes('GET_PROFILE');

export const GET_COUPON_FAVORITE_ASYNC = createSingleAndManyAsyncTypes(
  'GET_COUPONFAVORITE',
);
export const GET_BOOKMARK_ASYNC = createSingleAndManyAsyncTypes('GET_BOOKMARK');
export const GET_BUILD_ASYNC = createSingleAndManyAsyncTypes('GET_BUILD');
export const GET_NOTIFICATION_ASYNC = createSingleAndManyAsyncTypes(
  'GET_NOTIFICATION',
);
export const GET_OFFERING_ASYNC = createSingleAndManyAsyncTypes('GET_OFFERING');
export const GET_MYOFFERING_ASYNC = createSingleAndManyAsyncTypes(
  'GET_MYOFFERING',
);
export const GET_OFFERINGVIDEO_ASYNC = createNestedAsyncTypes(
  'GET_OFFERINGVIDEO',
);
export const GET_WANTED_ASYNC = createSingleAndManyAsyncTypes('GET_WANTED');
export const GET_MYWANTED_ASYNC = createSingleAndManyAsyncTypes('GET_MYWANTED');
export const GET_SUPPLYPROPOSAL_ASYNC = createSingleAndManyAsyncTypes(
  'GET_SUPPLYPROPOSAL',
);

export const GET_CATEGORY_ASYNC = createSingleAndManyAsyncTypes('GET_CATEGORY');
export const GET_CATEGORYSUMMARY_ASYNC = createSingleAndManyAsyncTypes(
  'GET_CATEGORYSUMMARY',
);
export const GET_ICON_ASYNC = createSingleAndManyAsyncTypes('GET_ICON');
export const GET_INVOICE_ASYNC = createSingleAndManyAsyncTypes(
  'GET_INVOICE_ASYNC',
);
export const GET_LAND_ASYNC = createSingleAndManyAsyncTypes('GET_LAND');
export const GET_PURCHASE_ASYNC = createSingleAndManyAsyncTypes('GET_PURCHASE');
export const GET_PURCHASESCHEMA_ASYNC = createSingleAndManyAsyncTypes(
  'GET_PURCHASESCHEMA',
);
export const GET_SALE_ASYNC = createSingleAndManyAsyncTypes('GET_SALE');
export const GET_SALESCHEMA_ASYNC = createSingleAndManyAsyncTypes(
  'GET_SALESCHEMA',
);
export const GET_PAYMENT_METHOD_ASYNC = createSingleAndManyAsyncTypes(
  'GET_PAYMENTMETHOD',
);
export const GET_ATTACHMENT_ASYNC = createSingleAndManyAsyncTypes(
  'GET_ATTACHMENT',
);
export const GET_QUESTION_ASYNC = createNestedAsyncTypes('GET_QUESTION');

export const GET_PURCHASETICKET_ASYNC = createSingleAndManyAsyncTypes(
  'GET_PURCHASETICKET_ASYNC',
);
export const GET_SALETICKET_ASYNC = createSingleAndManyAsyncTypes(
  'GET_SALETICKET_ASYNC',
);
export const GET_PURCHASELAND_ASYNC = createSingleAndManyAsyncTypes(
  'GET_PURCHASELAND_ASYNC',
);
export const GET_SALELAND_ASYNC = createSingleAndManyAsyncTypes(
  'GET_SALELAND_ASYNC',
);
export const GET_WAIVER_ASYNC = createNestedAsyncTypes('GET_WAIVER');

export const GET_CHAT_ASYNC = createSingleAndManyAsyncTypes('GET_CHAT_ASYNC');
export const GET_CHATMESSAGE_ASYNC = createSingleAndManyAsyncTypes(
  'GET_CHATMESSAGE_ASYNC',
);
export const GET_CHATUSER_ASYNC = createSingleAndManyAsyncTypes(
  'GET_CHATUSER_ASYNC',
);

export const GET_REVIEW_ASYNC = createSingleAndManyAsyncTypes(
  'GET_REVIEW_ASYNC',
);
export const GET_REVIEWDIMENSION_ASYNC = createSingleAndManyAsyncTypes(
  'GET_REVIEWDIMENSION_ASYNC',
);
export const GET_REVIEWSTAR_ASYNC = createNestedAsyncTypes(
  'GET_REVIEWSTAR_ASYNC',
);

export const GET_OFFERINGREVIEW_ASYNC = createSingleAndManyAsyncTypes(
  'GET_OFFERINGREVIEW_ASYNC',
);
export const GET_SALEREVIEW_ASYNC = createSingleAndManyAsyncTypes(
  'GET_SALEREVIEW_ASYNC',
);

// Google Analytics
export const GA_SIGNUP = 'GA_SIGNUP';
export const GA_LOGIN = 'GA_LOGIN';
export const GA_QUOTE = 'GA_QUOTE';
export const GA_FIELD_DRAWN = 'GA_FIELD_DRAWN';
export const GA_PAYMENT_ACCOUNT_ADDED = 'GA_PAYMENT_ACCOUNT_ADDED';
export const GA_COUPON_FAVORITE_ADDED = 'GA_COUPON_FAVORITE_ADDED';
export const GA_COUPON_USED_SELLER = 'GA_COUPON_USED_SELLER';
export const GA_COUPON_USED_BUYER = 'GA_COUPON_USED_BUYER';
export const GA_TRANSACTION_CREATED = 'GA_TRANSACTION_CREATED';
export const GA_QUESTION_ASKED = 'GA_QUESTION_ASKED';

export const GA_OFFERING_POSTING_CATEGORY_REACHED =
  'GA_OFFERING_POSTING_CATEGORY_REACHED';
export const GA_OFFERING_POSTING_DATES_REACHED =
  'GA_OFFERING_POSTING_DATES_REACHED';
export const GA_OFFERING_POSTING_EXTRA_FIELDS_REACHED =
  'GA_OFFERING_POSTING_EXTRA_FIELDS_REACHED';
export const GA_OFFERING_POSTING_IMAGES_REACHED =
  'GA_OFFERING_POSTING_IMAGES_REACHED';
export const GA_OFFERING_POSTING_LOCATION_REACHED =
  'GA_OFFERING_POSTING_LOCATION_REACHED';
export const GA_OFFERING_POSTING_PRICING_REACHED =
  'GA_OFFERING_POSTING_PRICING_REACHED';
export const GA_OFFERING_POSTING_BANK_DETAILS_REACHED =
  'GA_OFFERING_POSTING_BANK_DETAILS_REACHED';
export const GA_OFFERING_POSTING_TITLE_DESCRIPTION_REACHED =
  'GA_OFFERING_POSTING_TITLE_DESCRIPTION_REACHED';
export const GA_OFFERING_POSTING_SUBMIT_REACHED =
  'GA_OFFERING_POSTING_SUBMIT_REACHED';
export const GA_OFFERING_CREATED = 'GA_OFFERING_CREATED';

// Misc stuff
export const MISC_EMAIL = 'MISC_EMAIL';
export const SESSION_ONLINE = 'SESSION_ONLINE';
export const SESSION_OFFLINE = 'SESSION_OFFLINE';
export const PREPOPULATE_OFFERINGS = 'PREPOPULATE_OFFERINGS';
export const PREPOPULATE_WANTEDS = 'PREPOPULATE_WANTEDS';
